import * as Constants from '../constants/CartConstants';

export const setCart = (payload:any) => {
    return {
        type:Constants.SET_CART,
        data:payload
    }
}

export const modifyCart = (payload:any) => {
    return {
        type:Constants.MODIFY_CART,
        data:payload
    }
}

export const clearCart = (payload:any) => {
    return {
        type:Constants.CLEAR_CART,
        data:payload
    }
}

export const setCoupons = (payload:any) => {
    return {
        type:Constants.SET_COUPONS,
        data:payload
    }
}

export const updateDiscardedCart = (payload:any) => {
    return {
        type:Constants.UPDATE_DISCARDED_CART,
        data:payload
    }
}

export const softUpdateCart = (payload:any) => {
    return {
        type: Constants.SOFT_UPDATE_CART,
        data:payload
    }
}